(ns frontend.view.nev.kyc.process-status-views.edit-view
  (:require
   [basic-components.inputs.footprint :refer [viewer]]
   [common.util :as cu]
   [frontend.view.nev.kyc.process.kyc-editor :as kyc-editor]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [frontend.view.nev.kyc.process.editor-utils :as editor-utils]
   [common.schema.entities.workspace.kyc.templates.template-registry :as template-registry]
   [common.schema.entities.workspace.kyc.questions.prefill-data :as prefill-data]
   [frontend.view.nev.kyc.process.screening-profile-table :as screening-table]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn fill-updates-form-CRM
  [state-atom answers-atom kyc-process-from-session]
  (let [target-id (:kyc-process/target kyc-process-from-session)
        target (session/get-entity target-id)
        legal-entity (session/get-entity (:investor/legal-entity target))
        template (:kyc-process/template kyc-process-from-session)
        template-schema (template-registry/templates template)
        default-data (prefill-data/default-data template-schema legal-entity)
        kyc-process-from-state @state-atom
        session-stale? (when kyc-process-from-state
                         (let [state-updated-on (:common/updated-on kyc-process-from-state)
                               session-updated-on (:common/updated-on kyc-process-from-session)]
                           (when (and state-updated-on session-updated-on)
                             (< session-updated-on state-updated-on))))
        answers (if session-stale?
                  (:kyc-process/answers kyc-process-from-state)
                  (:kyc-process/answers kyc-process-from-session))]
    (reset! answers-atom (cu/remove-nil-vals (merge default-data ;; possible updates from CRM
                                                    (when (map? answers)
                                                      answers))))
    (deref answers-atom)))

(defn view
  [{:keys [state-atom loading-atom entity field-errors-atom]}]
  (let [template-schema (template-registry/templates (:kyc-process/template entity))
        answers (:kyc-process/answers entity)
        answers-atom (r/cursor state-atom [:kyc-process/answers])]
    (fill-updates-form-CRM state-atom answers-atom entity)
    (fn [{:keys [lang state-atom entity save! mandatory? read-only? header-renderer
                 footer-renderer]}]
      (let [lang-kw (if (= :FIN lang) :fi :en)]
        [:div.d-flex.flex-column.flex-1-hidden
         [:div.d-flex.flex-column.flex-1-hidden.scroll-y-container
          [:div.d-flex.flex-column.flex-1-hidden.scroll-y
           [:div
            (when header-renderer
              [header-renderer state-atom answers-atom entity])
            [:div.container.pt-4
             [:div.card--kyc
              [:div.card-body
               [viewer
                {:editor/type :editor.type/wysiwyg
                 :value       (some-> template-schema
                                      :kyc-template/kyc-form-preface
                                      (get lang-kw))}]]]]
            [kyc-editor/kyc-entity-editor
             {:state-atom      state-atom
              :container-id    "kyc-edit-view"
              :process-id      (:db/id entity)
              :save!           save!
              :answers-atom    answers-atom
              :loading-atom    loading-atom
              :template-schema template-schema
              :field-errors-atom field-errors-atom
              :read-only?      read-only?
              :mandatory?      mandatory?
              :lang-kw         lang-kw}]

            (when (and (session/screening?)
                       (tenant-customizations/capman?)    ; Todo - component requires changes for other tenants
                       (some #{(:kyc-process/status entity)}
                             [:kyc-process.status/waiting-for-e-sign
                              :kyc-process.status/submitted
                              :kyc-process.status/approved
                              :kyc-process.status/approved-modified]))
              [screening-table/view
               {:kyc-process  entity
                :answers-atom answers-atom}])]]]

         (when footer-renderer
           (let [invalid-questions
                 (if (not mandatory?)
                   []
                   (->>
                    template-schema
                    (remove (fn [[_ section-meta]]
                              (editor-utils/hide-section? answers entity section-meta)))
                    (mapcat
                     (fn [[_ metadata]]
                       (->> metadata
                            :questions
                            (remove (fn [[_ m]]
                                      (editor-utils/hide-question? answers entity m)))
                            (filter (fn [[q m]]
                                      (editor-utils/missing-mandatory-value? q m answers entity)))
                            (keep (fn [[q m]]
                                    (when-not (get @answers-atom q)
                                      (->> m
                                           :translations
                                           lang-kw)))))))))]
             (footer-renderer state-atom answers-atom entity invalid-questions)))]))))

